import styled from 'styled-components'

import { ContactListType } from '../contacts.types'
import { BuyerList } from './components/BuyerList/BuyerList'
import { SalesRepList } from './components/SalesRepList/SalesRepList'

export enum ContactListTestIds {
  Component = 'contact-list-component',
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
export const ContactList = ({
  salesRepresentatives,
  buyers,
  onClickAssignBuyerButton,
  showAssignBuyerButton = false,
}: ContactListType) => (
  <Container data-testid={ContactListTestIds.Component}>
    <SalesRepList salesRepresentatives={salesRepresentatives} />
    <BuyerList
      showAssignBuyerButton={showAssignBuyerButton}
      onClickAssignBuyerButton={onClickAssignBuyerButton}
      buyers={buyers || []}
    />
  </Container>
)
